/* eslint-disable max-len */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { fontSize, fontFamily } from '../../constants/text';
import Modal from '../SolvPatternLibrary/Modal';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import {
  BUTTON_STATUS_INITIAL,
  BUTTON_STATUS_LOADING,
} from '../SolvPatternLibrary/Button/TransitionButton';

import TosLinks from './TosLinks';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 0 0 16px;
`;

const Content = styled.div`
  font-size: ${fontSize.default};
`;

const AcceptContainer = styled.div`
  text-align: center;
`;

const CancelContainer = styled.div`
  text-align: center;
  button {
    font-size: ${fontSize.default};
  }
`;

type Props = {
  accountId?: string;
  title: string;
  clearLogin: () => void;
  setTosAccepted: (accountId?: string) => void;
};

const defaultProps = {
  title: 'Our Terms of Service and Privacy Policy have changed',
};

type State = { submitting: boolean };

class TosUpdate extends PureComponent<Props & typeof defaultProps, State> {
  static defaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    this.state = {
      submitting: false,
    };
  }

  onAccept = () => {
    this.props.setTosAccepted(this.props.accountId);
    this.setState({ submitting: true });
  };

  onReject = () => this.props.clearLogin();

  getButtonStatus = () => (this.state.submitting ? BUTTON_STATUS_LOADING : BUTTON_STATUS_INITIAL);

  renderActions = () => (
    <ButtonContainer>
      <AcceptContainer>
        <Button
          animationEnabled
          onClick={this.onAccept}
          status={this.getButtonStatus()}
          variation={ButtonVariations.pinkPrimarySmall}
        >
          Agree
        </Button>
      </AcceptContainer>

      <CancelContainer>
        <Button onClick={this.onReject} variation="link">
          Cancel
        </Button>
      </CancelContainer>
    </ButtonContainer>
  );

  render = () => (
    <Modal actions={this.renderActions()} open title={this.props.title}>
      <Content>
        <TosLinks />
      </Content>
    </Modal>
  );
}

export default TosUpdate;
